import { useEffect, useMemo, useState } from 'preact/hooks'
import clsx from 'clsx'

import { useFlickity } from '@/components/hooks/useFlickity'
import { DEFAULT_IMAGE_WIDTHS, getImgProps } from 'libs/athos/components/ResultImage'

const CAROUSEL_OPTIONS = {
  cellAlign: 'left',
  contain: true,
  pageDots: true,
  prevNextButtons: false,
  draggable: true,
  wrapAround: false
}

export function ResultCarousel({
  result,
  className = '',
  eager = false,
  sizes = '50vw',
  widths = DEFAULT_IMAGE_WIDTHS,
  width = 400,
  height = 500
}) {
  const [node, setNode] = useState()

  const slides = useMemo(() => {
    const media = result?.images?.length
      ? result.images
      : result?.image
        ? [{ src: result.image }]
        : []
    return media.slice(0, 2).filter((item) => item?.src)
  }, [result?.images, result?.image])

  const { SliderPortal } = useFlickity(node, CAROUSEL_OPTIONS, [node, slides.length])

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [slides])

  if (!slides.length) return null

  return (
    <div className={clsx('relative size-full overflow-hidden border-0 [&_.flickity-page-dots]:absolute [&_.flickity-page-dots]:inset-bl [&_.flickity-page-dots]:w-full [&_.flickity-page-dots]:z-2 [&_.flickity-page-dot]:bg-transparent [&_.flickity-page-dot.is-selected]:bg-primary', className)}>
      <div ref={setNode} className="flex size-full">
        <SliderPortal>
          {slides.map((media, index) => {
            const isEager = index === 0 && eager
            return (
              <div key={media.src} className="w-full aspect-1/1 shrink-0">
                <img
                  className={clsx(
                    !isEager && 'lazy',
                    'object-cover size-full bg-secondary'
                  )}
                  {...getImgProps({
                    src: media.src,
                    alt: media.alt || result.title || `Product image ${index + 1}`,
                    sizes,
                    eager: isEager,
                    width,
                    height,
                    widths
                  })}
                />
              </div>
            )
          })}
        </SliderPortal>
      </div>
    </div>
  )
}
